import React from 'react';
import { NavLink } from 'react-router-dom';

const ADMIN_BASE = '/admin';

const TABS = [
  { id: 'dashboard', label: 'Dashboard', path: `${ADMIN_BASE}/dashboard`, icon: 'D' },
  { id: 'products', label: 'Products', path: `${ADMIN_BASE}/products`, icon: 'P' },
  { id: 'orders', label: 'Orders', path: `${ADMIN_BASE}/orders`, icon: 'O' },
  { id: 'reports', label: 'Reports', path: `${ADMIN_BASE}/reports`, icon: 'R' },
  { id: 'users', label: 'User Approval', path: `${ADMIN_BASE}/users`, icon: 'A' },
  { id: 'banners', label: 'Banners', path: `${ADMIN_BASE}/banners`, icon: 'B' },
  { id: 'notifications', label: 'Notifications', path: `${ADMIN_BASE}/notifications`, icon: 'N' },
];

const Layout = ({
  children,
  loggedIn,
  sessionName,
  handleLogout,
}) => {
  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <div className="logo">H</div>
          <div>
            <div className="brand-title">HastagAdmin</div>
            <div className="brand-sub">Wholesale Operations Hub</div>
          </div>
        </div>
        {loggedIn ? (
          <>
            <div className="sidebar-section-label">Operations</div>
            <div className="nav">
              {TABS.map((t) => (
                <NavLink
                  key={t.id}
                  to={t.path}
                  className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                >
                  <span className="nav-icon">{t.icon || t.label[0]}</span>
                  <span>{t.label}</span>
                </NavLink>
              ))}
            </div>
            <div className="sidebar-footer">HastagAdmin v0.0.1</div>
          </>
        ) : (
          <div className="sidebar-guest">Secure login required to access admin tools.</div>
        )}
      </aside>

      <div className="content">
        <header className="topbar">
          <div className="topbar-brand">
            <div className="topbar-title">Hashtag B2B Admin</div>
            <div className="topbar-subtitle">Merchandising, orders, and growth in one place</div>
          </div>
          <div className="topbar-search">
            <input placeholder="Search products, orders, users..." />
          </div>
          <div className="session">
            {loggedIn ? (
              <NavLink
                to={`${ADMIN_BASE}/settings`}
                className={({ isActive }) => `icon-btn icon-btn-link top-settings-link ${isActive ? 'active' : ''}`}
              >
                <span className="top-settings-symbol" aria-hidden="true">&#9881;</span>
                <span className="top-settings-text">Settings</span>
              </NavLink>
            ) : null}
            <div className="profile-pill">
              <div className="profile-dot" />
              <span>{loggedIn ? sessionName : 'Not logged in'}</span>
            </div>
            {loggedIn ? <button className="secondary" onClick={handleLogout}>Logout</button> : null}
          </div>
        </header>
        <main className="main">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
